module.exports = __webpack_public_path__ + "img/male_AP_02.f2031ac7.png";